import { Failure, Loading, Success } from '@/assets/images';
import classNames from 'classnames';
import React, { HTMLAttributes } from 'react';
import { CSSTransition } from 'react-transition-group';
import './Loader.scss';

export enum Status {
	NONE,
	LOADING,
	SUCCESS,
	FAILURE
}

type Props = HTMLAttributes<HTMLDivElement> & {
	status?: Status;
};

export default function Loader({
	status = Status.LOADING,
	className
}: Props): JSX.Element {
	const nodeRef = React.useRef(null);
	return (
		<div
			className={classNames('loader relative overflow-hidden', className)}
		>
			<CSSTransition
				in={status === Status.LOADING}
				timeout={1000}
				classNames="fade"
				unmountOnExit
				nodeRef={nodeRef}
			>
				<img
					width={48}
					height={48}
					className="absolute h-full"
					src={Loading}
					alt="Loading..."
				/>
			</CSSTransition>

			<CSSTransition
				in={status === Status.SUCCESS}
				timeout={1000}
				classNames="fade"
				unmountOnExit
				nodeRef={nodeRef}
			>
				<img
					width={48}
					height={48}
					className="absolute h-full"
					src={Success}
					alt="Success"
				/>
			</CSSTransition>

			<CSSTransition
				in={status === Status.FAILURE}
				timeout={1000}
				classNames="fade"
				unmountOnExit
				nodeRef={nodeRef}
			>
				<img
					width={48}
					height={48}
					className="absolute h-full"
					src={Failure}
					alt="Failure"
				/>
			</CSSTransition>
		</div>
	);
}
